import { render, staticRenderFns } from "./azteclegend.vue?vue&type=template&id=312c5ea6&scoped=true"
import script from "./azteclegend.vue?vue&type=script&lang=js"
export * from "./azteclegend.vue?vue&type=script&lang=js"
import style0 from "./azteclegend.vue?vue&type=style&index=0&id=312c5ea6&prod&scoped=true&lang=css"
import style1 from "./azteclegend.vue?vue&type=style&index=1&id=312c5ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c5ea6",
  null
  
)

export default component.exports